import { Skeleton } from '@any-ui-react/core';
import { useMemo } from 'react';

import { EmployeeAlertPriorityBadge } from '@/common/components/shared/badge';
import { EmployeeAlertPriority } from '@/common/graphql';

import type { GetDashboardEmployeeAlertQuery } from '../../graphql';
import { DashboardSection } from '../DashboardSection';

interface Props {
  className?: string;
  employeeAlert: GetDashboardEmployeeAlertQuery | null | undefined;
  loading: boolean;
}

export const EmployeeAlert = ({ className, employeeAlert, loading }: Props) => {
  const countByPriority = useMemo(
    () => employeeAlert?.listEmployeeAlertsByCountry?.countByPriority,
    [employeeAlert?.listEmployeeAlertsByCountry?.countByPriority],
  );

  const entriesByPriority = useMemo(() => {
    const map = {
      [EmployeeAlertPriority.High]: countByPriority?.high,
      [EmployeeAlertPriority.Medium]: countByPriority?.medium,
      [EmployeeAlertPriority.Low]: countByPriority?.low,
    };

    return Object.entries(map) as [[EmployeeAlertPriority, number | undefined]];
  }, [countByPriority]);

  if (!countByPriority) {
    return <></>;
  }

  return (
    <DashboardSection className={className} link="/employees/alert" linkTitle="View all" title="Alerts for Admin users">
      {loading ? (
        <Skeleton className="h-5 w-[240px] rounded-full" />
      ) : (
        <div className="flex flex-wrap gap-4">
          {entriesByPriority.map(([priority, value]) => (
            <div key={priority} className="flex items-center gap-2">
              <EmployeeAlertPriorityBadge priority={priority} />
              <span>{value}</span>
            </div>
          ))}
        </div>
      )}
    </DashboardSection>
  );
};
